interface TopicItem {
  id: number;
  name: string;
  heat: string;
}

const topics: TopicItem[] = [
  { id: 1, name: '#香香漫画推荐', heat: '128万讨论' },
  { id: 2, name: '#斗破苍穹最新话', heat: '96万讨论' },
  { id: 3, name: '#下拉式阅读体验', heat: '83万讨论' },
  { id: 4, name: '#好看的漫画免费', heat: '75万讨论' },
  { id: 5, name: '#一人之下剧情', heat: '68万讨论' },
  { id: 6, name: '#咒术回战结局', heat: '61万讨论' },
  { id: 7, name: '#漫画追更日常', heat: '54万讨论' },
  { id: 8, name: '#仙王最新话', heat: '47万讨论' },
  { id: 9, name: '#免费漫画大全', heat: '42万讨论' },
];

export default function Topics() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1200px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">热门话题</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">漫画迷们正在热议的话题，加入讨论吧</p>
        </div>
        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topics.map((item) => (
            <div
              key={item.id}
              className="group flex items-center gap-2 px-4 py-2.5 md:px-5 md:py-3 rounded-full bg-background-100 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50 transition-all duration-200 cursor-pointer"
            >
              <span className="text-sm md:text-base font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {item.name}
              </span>
              <span className="text-[10px] md:text-xs text-foreground-500 bg-background-200/70 px-2 py-0.5 rounded-full whitespace-nowrap">
                {item.heat}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}